/**
 * The team-invitation token from a signup link (/register?invite=…), kept until
 * the new user is signed in. Signup does not create a session — the email has
 * to be verified first — so the token has to outlive the register screen.
 * Stored in localStorage; every access is guarded (private mode, blocked
 * storage), and losing it only falls back to the backend's email match.
 */
const KEY = "gg.pendingInviteToken";

export const savePendingInvite = (token: string): void => {
  try {
    window.localStorage.setItem(KEY, token);
  } catch {
    /* storage unavailable — the email match still applies */
  }
};

/** Read and forget the stored token: it is redeemed at most once. */
export const takePendingInvite = (): string | null => {
  try {
    const token = window.localStorage.getItem(KEY);
    if (token) window.localStorage.removeItem(KEY);
    return token;
  } catch {
    return null;
  }
};
